import myHealth from '@web/containers/MyHealth/localization'
import _ from 'lodash'

const localization = {
  en: {
    view: ' View',
    loading: '',
    textResults: 'Test Results',
    test: 'Test',
    orderProvider: 'Order Provider',
    details: 'Details',
    dates: 'DATE',
    startDate: 'Start Date',
    endDate: 'End Date',
    filterByDateRange: 'Filter By Date Range',
    submit: 'Filter',
    reset: 'Reset'
  },
  es: {
    view: ' Ver',
    loading: '',
    textResults: 'Resultados de la prueba',
    test: 'Examen',
    orderProvider: 'Solicitar un profesional de la salud',
    details: 'Detalles',
    dates: 'Fecha',
    past: 'Resultados anteriores',
    startDate: 'Inicio',
    endDate: 'Término',
    filterByDateRange: 'Filtrar por rango de fecha',
    submit: 'Filtrar',
    reset: 'Restablecer'
  },
  keyMapping: {
    loading: '',
    orderProvider: 'UFD_Order_Provider_Text',
    startDate: 'UFD_Start_Date_Text',
    endDate: 'UFD_End_Date_Text',
    filterByDateRange: 'UFD_Filter_By_Date_Range',
    submit: 'UFD_Filter_Button',
    reset: 'UFD_Reset_Button',
    view: '',
    textResults: 'UFD_Test_Results_Text',
    test: '',
    details: '',
    dates: ''
  }
}

export default _.merge(myHealth, localization)
